import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
    selector: 'tt-invoice-make-multi',
    templateUrl: './invoice-make-multi.component.html',
    styleUrls: ['./invoice-make-multi.component.css'],
    standalone: false
})
export class InvoiceMakeMultiComponent implements OnInit {
    businessCoNo;

    invoiceMethodNo;

    invoiceValutaId;

    public selectedBgInvoiceMakeMultiMain: string = 'SELECT';

    public setting?: Setting;

    public itemsListCreateMultiInvoices: Item[] = [];

    public grid?: GridOptions;

    public showSelectAll = false;

    public showUnselectAll = false;

    public creating = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.businessCoNo = this.stateService.getStateParams()['businessco_no'];
        this.invoiceMethodNo = this.stateService.getStateParams()['invoicemethod_no'];
        this.invoiceValutaId = this.stateService.getStateParams()['invoice_valuta_id'];
    }

    private async loadSetting() {
        if (!!this.businessCoNo && !!this.invoiceMethodNo && !!this.invoiceValutaId) {
            this.setting = (await this.datatask.Post(829, {
                businessco_no: this.businessCoNo,
                invoicemethod_no: this.invoiceMethodNo,
                invoice_valuta_id: this.invoiceValutaId
            }))[0];
        }
    }

    private async loadCreateMultiInvoices() {
        if (!this.setting) return;

        this.itemsListCreateMultiInvoices = await this.datatask.Post(830, this.setting);
        
        this.itemsListCreateMultiInvoices.forEach((item) => {
            if (item.item_id !== '0' && item.item_id !== '-1') {
                this.showSelectAll = false;
                this.showUnselectAll = true;
            } else {
                this.showSelectAll = true;
                this.showUnselectAll = false;
            }
        });
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_invoicemakemulti.grid')
                .setLoadDataFunction({
                    method: 3698,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([{
                    name: 'invoicemakemulti_create_invoices',
                    text: 'invoicemakemulti_create_invoices',
                    tooltip: 'invoicemakemulti_create_invoices',
                    translateTooltip: true,
                    func: () => this.createGridInvoices(),
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--success im-grid-btn-xs-r',
                    translate: true,
                    disable_if_no_selected: true
                }]);
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public async createItemsListInvoices() {
        let selectedRows: any = [];

        this.itemsListCreateMultiInvoices.forEach((item) => {
            if (item.item_is_selected === '1') {
                this.creating = true;
                selectedRows.push(item);
            }
        });

        if (selectedRows.length === 0 || !this.setting) return;

        let count = 0;

        const progressModal = this.modal.openProgressDialog({
            rememberId: 'w_invoicemakemulti_progressmodal',
            value: count,
            max: selectedRows.length
        });

        for (let row of selectedRows) {
            const { errorcode, errormessage } = (await this.datatask.Post(1761, {
                invoicemethod_no: this.setting!.invoicemethod_no,
                invoice_date: this.setting!.invoice_date,
                businessco_no: this.setting!.businessco_no,
                order_internal_no: row['order_internal_no'],
                item_id: row['item_id']
            }))[0];

            if ('' + errorcode !== '0') {
                progressModal.updateStatus('invalid');
                progressModal.updateInvalidText(errormessage);
                this.creating = false;
                break;
            }

            count = count + 1;
            progressModal.updateValue(count);
        }

        if (count === selectedRows.length) {
            progressModal.updateStatus('finish');
            this.creating = false;
        }

        this.loadCreateMultiInvoices();
    }

    private async createGridInvoices() {
        const selectedRows = this.grid?.gridfunc?.getIsSelectedRows() ?? [];

        if (selectedRows.length === 0 || !this.setting) return;

        let count = 0;

        const progressModal = this.modal.openProgressDialog({
            rememberId: 'w_invoicemakemulti_progressmodal',
            value: count,
            max: selectedRows.length
        });

        for (let row of selectedRows) {
            const { errorcode, errormessage } = (await this.datatask.Post(1761, {
                invoicemethod_no: this.setting!.invoicemethod_no,
                invoice_date: this.setting!.invoice_date,
                businessco_no: this.setting!.businessco_no,
                order_internal_no: row['order_internal_no'],
                item_id: row['item_id']
            }))[0];

            if ('' + errorcode !== '0') {
                progressModal.updateStatus('invalid');
                progressModal.updateInvalidText(errormessage);
                break;
            }

            count = count + 1;
            progressModal.updateValue(count);
        }

        if (count === selectedRows.length) {
            progressModal.updateStatus('finish');
        }

        this.loadGrid();
    }

    public selectAll(): void {
        this.itemsListCreateMultiInvoices.forEach((item) => {
            if (item.item_id === '0' || item.item_id === '-1') return;

            item.item_is_selected = '1';
            this.showSelectAll = false;
            this.showUnselectAll = true;
        });
    }

    public unselectAll(): void {
        this.itemsListCreateMultiInvoices.forEach((item) => {
            if (item.item_id === '0' || item.item_id === '-1') return;

            item.item_is_selected = '0';
            this.showSelectAll = true;
            this.showUnselectAll = false;
        });
    }

    toggleChosen(item: any): void {
        item = item?.item ? item.item : item;

        if (item.item_id === '0' || item.item_id === '-1') return;

        if (item.item_is_selected === '0') {
            item.item_is_selected = '1';
        } else if (item.item_is_selected === '1') {
            item.item_is_selected = '0';
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'deliverydate_tom':
            case 'invoice_date':
                this.loadCreateMultiInvoices();
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCreateMultiInvoices();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
    invoice_date: string;
    invoicemethod_no: string;
    deliverydate_tom: string;
    businessco_companyname: string;
    invoicemethod_name: string;
    invoice_valuta_id: string;
}
